import allImgPaths from "assets/images";
import ColumnBarChart from "components/common/charts/ColumnBarChart";
import React, { useState } from "react";
import InsightCardsOptions from "./InsightCardsOptions";
import { Modal } from "components/common/modal/Modal";
import { HeaderModal } from "components/common/modal/Header";
import { Body } from "components/common/modal/Body";

const BudgetUtilization = () => {
  const [showOptions, setShowOptions] = useState(false);
  const [openMaximizeModal, setOpenMaximizeModal] = useState(false);

  const listData = [
    {
      'listName': 'All',
    },
    {
      'listName': 'Assigned',
    },
    {
      'listName': 'Utilized',
    },
    {
      'listName': 'Sponsored',
    },
    {
      'listName': 'Saved',
    },

  ]

  const [isActive, setIsActive] = useState<any>(1);

  const MaximizeModal = () => {
    return (
      <Modal
        className={"modal-wrapper max-w-[1140px] relative"}
        isShow={openMaximizeModal}
      >
        <Body title='header' isShowBody={true} className=''>
          <img
            className='cursor-pointer absolute top-3 right-3'
            id='modal-toggle'
            src={allImgPaths.closeIcon}
            onClick={() => setOpenMaximizeModal(false)}
            alt='close icon'
          />
          <div className='pt-6 pb-0 px-6 bg-[#fff] rounded-xl'>
            {/* Upper Header */}
            <div className='flex items-center justify-between pb-5'>
              <div className=''>
                <div className='flex items-center justify-between'>
                  <h4 className='text-lg text-[#101828] font-interSemiBold pb-0.5'>
                    Budget Utilization
                  </h4>
                </div>
                <p className='text-sm font-interMedium text-[#98A2B3]'>
                  Description here
                </p>
              </div>

            </div>

            {/* Counts */}
            <div className='flex items-center gap-x-[26px] mb-5'>
              <div className='flex gap-x-3 items-start'>
                <img src={allImgPaths.assignedBudget} alt='' />
                <div className=''>
                  <p className='text-sm text-[#98A2B3] pb-1'>Assigned</p>
                  <h6 className='text-2xl text-[#1D1F2C] font-interSemiBold'>
                    $30k
                  </h6>
                </div>
              </div>

              <div className='flex gap-x-3 items-start'>
                <img src={allImgPaths.utilizedBudget} alt='' />
                <div className=''>
                  <p className='text-sm text-[#98A2B3] pb-1'>Utilized</p>
                  <h6 className='text-2xl text-[#1D1F2C] font-interSemiBold'>
                    $2k
                  </h6>
                </div>
              </div>

              <div className='flex gap-x-3 items-start'>
                <img src={allImgPaths.sponsoredBudget} alt='' />
                <div className=''>
                  <p className='text-sm text-[#98A2B3] pb-1'>Sponsored</p>

                  <h6 className='text-2xl text-[#1D1F2C] font-interSemiBold flex gap-x-2'>
                    $30k
                    <span className='text-[#079455] text-sm font-interMedium flex items-center gap-x-0.5'>
                      <img src={allImgPaths.trendUpIcon} alt='' /> 100%
                    </span>
                  </h6>
                </div>
              </div>

              <div className='flex gap-x-3 items-start'>
                <img src={allImgPaths.savedBudget} alt='' />
                <div className=''>
                  <p className='text-sm text-[#98A2B3] pb-1'>Saved</p>

                  <h6 className='text-2xl text-[#1D1F2C] font-interSemiBold flex gap-x-2'>
                    $28k
                    <span className='text-[#079455] text-sm font-interMedium flex items-center gap-x-0.5'>
                      <img src={allImgPaths.trendUpIcon} alt='' /> 100%
                    </span>
                  </h6>
                </div>
              </div>
            </div>

            {/* Graph */}
            <div className=''>
              <ColumnBarChart />
            </div>
          </div>

        </Body>
      </Modal>
    );
  };
  return (
    <>
      <div className='w-[calc(100%_-_390px)] pt-6 pb-0 px-6 bg-[#fff] rounded-xl border border-[#EAECF0]'>
        {/* Upper Header */}
        <div className='flex items-center justify-between pb-5'>
          <div className=''>
            <div className='flex items-center justify-between'>
              <h4 className='text-lg text-[#101828] font-interSemiBold pb-0.5'>
                Budget Utilization
              </h4>
            </div>
            <p className='text-sm font-interMedium text-[#98A2B3]'>
              Description here
            </p>
          </div>

          <div className='flex gap-x-3 items-center'>
            <ul className='flex items-center'>
              {
                listData.map((item, idx) => (
                  <li onClick={() => {
                    setIsActive(idx)
                  }} key={idx} className={`${isActive === idx ? "bg-[#f9fafb]" : "bg-[#fff]"} font-interSemiBold text-base text-[#667085] py-2.5 px-4 border border-[#D0D5DD] first:rounded-tl-lg first:rounded-bl-lg last:rounded-tr-lg last:rounded-tb-lg flex items-center gap-x-2 cursor-pointer hover:bg-[#f9fafb]`}>
                    <span className={`${isActive === idx ? "text-[#1e0af5]" : "text-[#344054]"} text-sm font-interSemiBold`}>
                      {item.listName}
                    </span>
                  </li>
                ))
              }
            </ul>

            <div
              className='p-1 cursor-pointer relative hover:bg-[#f2f4f7] rounded w-5 focus-within:bg-[#f2f4f7]'
              onClick={() => setShowOptions(!showOptions)}
            >
              <img className="mx-auto" src={allImgPaths.threeVerticleDotsIcon} alt='three dots' />
              <InsightCardsOptions
                isShow={showOptions}
                openMaximizeModal={() => setOpenMaximizeModal(true)}
                chartName='column_bar_chart'
                downloadChartName='budgetUtilize'
              />
            </div>
          </div>
        </div>

        {/* Counts */}
        <div className='flex items-center gap-x-[26px] mb-5'>
          <div className='flex gap-x-3 items-start'>
            <img src={allImgPaths.assignedBudget} alt='' />
            <div className=''>
              <p className='text-sm text-[#98A2B3] pb-1'>Assigned</p>
              <h6 className='text-2xl text-[#1D1F2C] font-interSemiBold'>
                $30k
              </h6>
            </div>
          </div>

          <div className='flex gap-x-3 items-start'>
            <img src={allImgPaths.utilizedBudget} alt='' />
            <div className=''>
              <p className='text-sm text-[#98A2B3] pb-1'>Utilized</p>
              <h6 className='text-2xl text-[#1D1F2C] font-interSemiBold'>
                $2k
              </h6>
            </div>
          </div>

          <div className='flex gap-x-3 items-start'>
            <img src={allImgPaths.sponsoredBudget} alt='' />
            <div className=''>
              <p className='text-sm text-[#98A2B3] pb-1'>Sponsored</p>

              <h6 className='text-2xl text-[#1D1F2C] font-interSemiBold flex gap-x-2'>
                $30k
                <span className='text-[#079455] text-sm font-interMedium flex items-center gap-x-0.5'>
                  <img src={allImgPaths.trendUpIcon} alt='' /> 100%
                </span>
              </h6>
            </div>
          </div>

          <div className='flex gap-x-3 items-start'>
            <img src={allImgPaths.savedBudget} alt='' />
            <div className=''>
              <p className='text-sm text-[#98A2B3] pb-1'>Saved</p>

              <h6 className='text-2xl text-[#1D1F2C] font-interSemiBold flex gap-x-2'>
                $28k
                <span className='text-[#079455] text-sm font-interMedium flex items-center gap-x-0.5'>
                  <img src={allImgPaths.trendUpIcon} alt='' /> 100%
                </span>
              </h6>
            </div>
          </div>
        </div>

        {/* Graph */}
        <div className=''>
          <ColumnBarChart />
        </div>
      </div>
      <MaximizeModal />
    </>
  );
};

export default BudgetUtilization;
